import styled from 'styled-components';
import {
  Year,
  Make,
  Model,
  TrimVin
} from '../../../components/Vdp/Overview/VehicleInfo/Styles';
import Icon from '../../../_shared/components/Icon';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 32px 0;
  margin-right: 66px;
  border-bottom: 1px solid
    ${({ theme }) =>
      isOmp ? theme.COLORS.NEUTRAL_110 : theme.COLORS.NEUTRAL_30};
  max-width: 480px;
  height: max-content;
  grid-column-start: 1;
  grid-row-start: 1;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    margin: 20px;
    padding: 0 0 20px 0;
  }
`;

export const StyledYear = styled(Year)``;

export const StyledMake = styled(Make)``;

export const StyledModel = styled(Model)``;

export const StyledTrim = styled(TrimVin)`
  width: 100%;
  margin-top: 6px;
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
`;

export const FuelEconomyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 32px;
  svg {
    height: 38px;
    width: 38px;
  }
`;

export const OmpPumpIcon = styled(Icon)`
  && {
    height: 50px;
  }
`;

export const FuelType = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  margin-left: 24px;
`;

export const FuelContainer = styled.div``;

export const FuelAmount = styled.span`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  margin-right: 3px;
`;

export const FuelUnit = styled.span`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;
